import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import TextField from "@mui/material/TextField";
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Rodape from '../Components/Rodape';
import { useAuth } from '../context/AuthContext'; // <== se você estiver usando o AuthContext

const Home = () => {
  const [user, setUser] = useState('');
  const [pwd, setPwd] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth(); // para armazenar login globalmente

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        'http://api.sigmasystems.com.br/api/topdistribuidora/login-client',
        { user, pwd }
      );

      // verifica sucesso
      if (response.data.success) {
        // salva token e dados no localStorage
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));

        // se estiver usando o contexto global de autenticação:
        if (login) login(response.data.user, 'cliente');

        navigate('/CATEGORIAS');
      } else {
        alert('Usuário ou senha inválido!');
      }
    } catch (error) {
      console.error(error);
      alert('Erro ao conectar com o servidor ou credenciais inválidas.');
    }
  };

  return (
    <div className="container">
      <div className="content">
        <div className="leftSide">
          <div className="wellcome-box">
            <h2 className="wellcome">Bem-vindo</h2>
            <h2 className="wellcome-desc">Acesse nosso catálogo de produtos.</h2>
          </div>

          <div className="contact">
            <h2 className="contact-us">Entre em contato conosco!</h2>
            <a href="https://wa.me/+554599224018">
              <button className="whatsapp">
                <WhatsAppIcon fontSize="small" sx={{ paddingRight: 0.5 }} />
                Contato
              </button>
            </a>
          </div>
        </div>

        <div className="rightSide">
          <img className="logoTopHome" src="./images/toplogo.png" alt="Logo Top" />

          <form
            onSubmit={handleLogin}
            className="formLoginClient"
            style={{ marginTop: 30, display: 'flex', flexDirection: 'column' }}
          >
            <TextField
              id="outlined-basic"
              label="Usuário"
              variant="outlined"
              sx={{ width: 300, backgroundColor: '#fff', borderRadius: 1 }}
              color="error"
              value={user}
              onChange={(e) => setUser(e.target.value)}
            />

            <FormControl
              sx={{ width: 300, marginTop: 1, backgroundColor: '#fff', borderRadius: 1 }}
              color="error"
              variant="outlined"
            >
              <InputLabel htmlFor="outlined-adornment-password">Senha</InputLabel>
              <OutlinedInput
                id="outlined-adornment-password"
                type={showPassword ? 'text' : 'password'}
                value={pwd}
                onChange={(e) => setPwd(e.target.value)}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
                label="Senha"
              />
            </FormControl>

            <button
              type="submit"
              className="btnCatalogo"
              style={{ marginTop: 20 }}
            >
              ACESSAR CATÁLOGO
            </button>
          </form>
        </div>
      </div>

      <Rodape />
    </div>
  );
};

export default Home;
